/* eslint-disable @typescript-eslint/no-explicit-any */
import { TranslateService } from '@ngx-translate/core';
import { Confirmation } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export function defaultDialogConfig(
  header: string,
  data?: any,
  width?: string,
  height?: string,
  prop: any = {}
): DynamicDialogConfig {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  return {
    dismissableMask: true,
    draggable: true,
    resizable: true,
    closable: true,
    maximizable: true,
    styleClass: 'surface-dialog',
    header,
    width: isMobile ? '100vw' : (width ?? 'auto'),
    height: isMobile ? '100vh' : (height ?? 'auto'),
    contentStyle: isMobile ? { padding: '0', overflow: 'auto' } : { height: '100%' },
    data,
    ...prop,
  };
}

export function deleteConfirmationOptions(translate: TranslateService): Confirmation {
  return {
    acceptLabel: translate.instant('common.delete'),
    rejectLabel: translate.instant('common.cancel'),
    acceptButtonStyleClass: 'p-button-danger',
    rejectButtonStyleClass: 'p-button-secondary',
    message: translate.instant('common.areYouSureToDelete'),
    header: translate.instant('common.confirmation'),
    icon: 'pi pi-exclamation-triangle',
  };
}

export function approveConfirmationOptions(translate: TranslateService): Confirmation {
  return {
    acceptLabel: translate.instant('common.approve'),
    rejectLabel: translate.instant('common.cancel'),
    acceptButtonStyleClass: 'p-button-success',
    rejectButtonStyleClass: 'p-button-secondary',
    header: translate.instant('common.confirmation'),
    icon: 'pi pi-exclamation-triangle',
  };
}

export function rejectConfirmationOptions(translate: TranslateService): Confirmation {
  return {
    acceptLabel: translate.instant('common.reject'),
    rejectLabel: translate.instant('common.cancel'),
    acceptButtonStyleClass: 'p-button-danger',
    rejectButtonStyleClass: 'p-button-secondary',
    header: translate.instant('common.confirmation'),
    icon: 'pi pi-exclamation-triangle',
  };
}

export function yesCancelConfirmationOptions(translate: TranslateService): Confirmation {
  return {
    acceptLabel: translate.instant('enum.bool.true'),
    rejectLabel: translate.instant('common.cancel'),
    header: translate.instant('common.confirmation'),
    icon: 'pi pi-exclamation-triangle',
    acceptButtonStyleClass: 'p-button-success',
  };
}
